// assets
import { AlertOutlined, DashboardOutlined, MobileOutlined } from '@ant-design/icons';
import GpsFixedOutlinedIcon from '@mui/icons-material/GpsFixedOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DevicesOtherOutlinedIcon from '@mui/icons-material/DevicesOtherOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import CrisisAlertOutlinedIcon from '@mui/icons-material/CrisisAlertOutlined';
import ImportantDevicesOutlinedIcon from '@mui/icons-material/ImportantDevicesOutlined';
import ShareLocationOutlinedIcon from '@mui/icons-material/ShareLocationOutlined';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import RingVolumeIcon from '@mui/icons-material/RingVolume';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { Icon } from '@iconify/react';

// ==============================|| MENU ITEMS ||============================== //

const isPartnerSession = typeof window !== 'undefined' && sessionStorage.getItem('is_partner_session') === 'true';

const menuItems = {
  items: [
    {
      id: 'group-dashboard',
      title: 'Navigation',
      type: 'group',
      children: [
        // {
        //   id: 'dashboard',
        //   title: 'Dashboard',
        //   type: 'item',
        //   url: '/dashboard/default',
        //   icon: DashboardOutlined,
        //   breadcrumbs: false
        // },
        {
          id: 'admin-stats',
          title: 'Admin Stats',
          type: 'item',
          url: '/admin-stats',
          icon: DevicesOtherOutlinedIcon,
          adminOnly: true
        },
        {
          id: 'device-info',
          title: 'Device Info',
          type: 'item',
          url: '/device-info',
          icon: DevicesOtherOutlinedIcon
        },
        {
          id: 'alert-page',
          title: 'Alerts',
          type: 'item',
          url: '/alert',
          icon: AlertOutlined
        },
        {
          id: 'gps-page',
          title: 'GPS Tracking',
          type: 'item',
          url: '/gps',
          icon: GpsFixedOutlinedIcon
        },
        {
          id: 'health-page',
          title: 'Health/Activity Data',
          type: 'item',
          url: '/health',
          icon: VolunteerActivismOutlinedIcon
        },
        {
          id: 'report-page',
          title: 'Reports',
          type: 'item',
          url: '/reports',
          icon: AssessmentOutlinedIcon
        },
        {
          id: 'usage-report-page',
          title: 'Usage Reports',
          type: 'item',
          url: '/usage-reports',
          icon: AssessmentOutlinedIcon,
          adminOnly: true
        },
        {
          id: 'device-settings-page',
          title: 'Device Settings',
          type: 'collapse',
          // url: '/settings',
          icon: SettingsSuggestOutlinedIcon,
          children: [
            // {
            //   id: 'devices',
            //   parentId: 'device-settings-page',
            //   title: 'Devices',
            //   type: 'collapseItem',
            //   url: '/settings/devices',
            //   icon: ImportantDevicesOutlinedIcon
            // },
            ...(!isPartnerSession ? [
              {
                id: 'set-device-name',
                parentId: 'device-settings-page',
                title: 'Set Device Name',
                type: 'collapseItem',
                url: '/settings/set-device-name',
                icon: ImportantDevicesOutlinedIcon
              }
            ] : []),
            {
              id: 'work-mode-settings',
              parentId: 'device-settings-page',
              title: 'Work Mode Settings',
              type: 'collapseItem',
              url: '/settings/work-mode-settings',
              iconifyIcon: 'fa6-solid:gear'
            },
            {
              id: 'sos-alert',
              parentId: 'device-settings-page',
              title: 'SOS Alert/Emails',
              type: 'collapseItem',
              url: '/settings/sos-alert',
              icon: CrisisAlertOutlinedIcon
            },
            {
              id: 'geo-fence-alert',
              parentId: 'device-settings-page',
              title: 'Geo-fence Alert',
              type: 'collapseItem',
              url: '/settings/geo-fence-alert',
              icon: ShareLocationOutlinedIcon
            },
            {
              id: 'fall-down-alert',
              parentId: 'device-settings-page',
              title: 'Fall Down Alert',
              type: 'collapseItem',
              url: '/settings/fall-down-alert',
              iconifyIcon: 'fa6-solid:person-falling'
            },
            {
              id: 'motion-alert',
              parentId: 'device-settings-page',
              title: 'Motion Alert ',
              type: 'collapseItem',
              url: '/settings/motion-alert',
              iconifyIcon: 'mdi:motion'
            },
            {
              id: 'no-motion-alert',
              parentId: 'device-settings-page',
              title: 'No Motion Alert ',
              type: 'collapseItem',
              url: '/settings/no-motion-alert',
              iconifyIcon: 'fa6-solid:person-circle-exclamation'
            },
            {
              id: 'mic-volume-settings',
              parentId: 'device-settings-page',
              title: 'Microphone Volume',
              type: 'collapseItem',
              url: '/settings/mic-volume-settings',
              iconifyIcon: 'fa6-solid:microphone-lines'
            },
            {
              id: 'speaker-volume-settings',
              parentId: 'device-settings-page',
              title: 'Speaker Volume',
              type: 'collapseItem',
              url: '/settings/speaker-volume-settings',
              iconifyIcon: 'fa6-solid:volume-low'
            },
            {
              id: 'voice-prompt-volume-settings',
              parentId: 'device-settings-page',
              title: 'Voice Prompt Volume',
              type: 'collapseItem',
              url: '/settings/voice-prompt-volume-settings',
              icon: RecordVoiceOverIcon
            },
            {
              id: 'ringtone-volume-settings',
              parentId: 'device-settings-page',
              title: 'Ring Tone Volume',
              type: 'collapseItem',
              url: '/settings/ringtone-volume-settings',
              icon: RingVolumeIcon
            },
            {
              id: 'tilt-alert',
              parentId: 'device-settings-page',
              title: 'Tilt Alert ',
              type: 'collapseItem',
              url: '/settings/tilt-alert',
              iconifyIcon: 'fa6-solid:arrows-rotate'
            },
            {
              id: 'over-speed-alert',
              parentId: 'device-settings-page',
              title: 'Over Speed Alert ',
              type: 'collapseItem',
              url: '/settings/over-speed-alert',
              iconifyIcon: 'fa6-solid:gauge-high'
            },
            {
              id: 'timezone-settings',
              parentId: 'device-settings-page',
              title: 'Time zone',
              type: 'collapseItem',
              url: '/settings/timezone',
              icon: AccessTimeOutlinedIcon
            }
          ]
        }
      ]
    }
  ]
};

export default menuItems;
